import { JSX, type Dispatch, type SetStateAction } from "react";

import { FmdGoodOutlined, ViewListOutlined } from "@mui/icons-material";
import { Button, ButtonGroup, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import sharedStyles from "src/constants/styles";

import FootfallViewType from "./footfallVileType.enum";

function FootfallViewSwitch({
  componentId,
  selectedViewType,
  setSelectedViewType,
  setView,
}: {
  componentId: string;
  selectedViewType: FootfallViewType;
  setSelectedViewType: Dispatch<SetStateAction<FootfallViewType>>;
  setView: (componentId: string, view: string) => void;
}): JSX.Element {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <ButtonGroup color='secondary' variant='outlined' sx={sharedStyles(theme).secondaryInverseButtonGroup}>
      <Button
        sx={sharedStyles(theme).secondaryInverseButtonGroupButton}
        disabled={selectedViewType === FootfallViewType.List}
        onClick={() => {
          setSelectedViewType(FootfallViewType.List);
          setView(componentId, FootfallViewType.List.toString());
        }}
        startIcon={<ViewListOutlined />}
      >
        {t("List")}
      </Button>
      <Button
        sx={sharedStyles(theme).secondaryInverseButtonGroupButton}
        disabled={selectedViewType === FootfallViewType.Map}
        onClick={() => {
          setSelectedViewType(FootfallViewType.Map);
          setView(componentId, FootfallViewType.Map.toString());
        }}
        startIcon={<FmdGoodOutlined />}
      >
        {t("Map")}
      </Button>
    </ButtonGroup>
  );
}

export default FootfallViewSwitch;
